import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-vbabutton',
  templateUrl: './page-vbabutton.component.html',
  styleUrls: ['./page-vbabutton.component.scss']
})
export class PageVBAbuttonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
